import {
  LabelledField
} from "lib-core"

export default LabelledField
